import { UserResource } from "@clerk/types";

const ADMIN_ROLE = "admin";
const AGENT_EDITOR_ROLE = "agent_editor";

export const isUserAdmin = (user: UserResource | null | undefined) => {
  return user?.publicMetadata?.lomanRole === ADMIN_ROLE;
};

export const isUserAgentEditor = (user: UserResource | null | undefined) => {
  return user?.publicMetadata?.lomanRole === AGENT_EDITOR_ROLE;
};
